module.exports = __webpack_public_path__ + "static/media/fi.55109a40.svg";